import { Button, Group, Modal } from "@mantine/core";
import { useState } from "react";
import { useLanguage } from "../../stores/LanguageStore";
import { getEmbedUrl } from "../../functions/utilFunctions";

const VideoModalViewer = ({ src, opener }) => {
  const lang = useLanguage((s) => s.language);
  const [opened, setOpened] = useState(false);

  const handleOpen = () => {
    setOpened(true);
  };

  const handleClose = () => {
    setOpened(false);
  };

  return (
    <>
      {opener(handleOpen)}

      <Modal
        opened={opened}
        withCloseButton={false}
        onClose={handleClose}
        size={1024}
        radius={"lg"}
      >
        {src.includes("youtube") ? (
          <iframe
            src={getEmbedUrl(src)}
            width="100%"
            height="500"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowfullscreen
            frameBorder={0}
            style={{
              borderRadius: 8,
            }}
          ></iframe>
        ) : (
          <video
            src={src}
            className="reseller-video"
            controls
            style={{
              width: "100%",
              height: "100%",
              display: "block",
            }}
          />
        )}
        <Group justify="center" mt={"md"}>
          <Button size="md" variant="subtle" onClick={handleClose} w={"50%"}>
            {lang.global.close}
          </Button>
        </Group>
      </Modal>
    </>
  );
};

export default VideoModalViewer;
